module.exports = __webpack_public_path__ + "static/media/congress2025.ed0dc218.jpg";